import type { AxiosInstance } from 'axios'

import { FrontendSetting } from '../../interfaces/setting'

export const getFrontendSetting = (api: AxiosInstance) => (): Promise<
  FrontendSetting
> => api.get('/v1.0/admin/settings/frontend')
